// Copyright (c) 2017 Deere & Company

import './report-header.scss';
import React, {PropTypes} from 'react';
import {
    getReportLayoutActions,
    getSelectedLayout
} from '../../services/report-variant';
import ActionPopover from '../../../../shared/components/actions-popover';
import CreateLayoutModal from '../report-variant-modals/create-layout-modal';
import DownloadToExcel from '../../../../shared/components/download-to-excel';
import ReportColumnState from '@deere/cps-it.warranty-model-factory/lib/report-layout-column-state';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ReportLayoutDropdown from '../../../shared/components/report-layout-dropdown';
import UpdateLayoutModal from '../report-variant-modals/update-layout-modal';
import {exportToCSV} from '../../services/export-to-csv';

function handleExportToCsv() {

    if (this.showResponsibleDealer) {

        return this.responsibleExportToCSV();

    }

    return exportToCSV(this.reportName, this.gridApi);

}

function onLayoutChange(selectedLayoutName) {

    const selectedLayout = getSelectedLayout(selectedLayoutName, this.layouts);

    this.actions.updateReportProperty('selectedLayout', selectedLayout);

}

const ReportGridHeader = props => {

    const numberOfHiddenFields = props.hiddenColumns.length;

    const actionList = getReportLayoutActions({
        openCreateLayoutModal: props.actions.updateCreateLayoutModal.bind(null, 'isOpen', true),
        openUpdateLayoutModal: props.actions.updateLayoutModal.bind(null, true),
        showReportColumns: props.actions.updateReportColumnsVisibility.bind(null, true)
    }, numberOfHiddenFields, props.selectedLayout);

    return (
        <section className='report-grid-header'>
            {props.isSapUp && props.showReportLayout &&
                <div className='report-variant'>
                    <ReportLayoutDropdown
                        className='report-layouts'
                        list={props.layouts}
                        onChange={props::onLayoutChange}
                        value={props.selectedLayout ? props.selectedLayout.name : ''}
                    />
                    <ActionPopover options={actionList}/>
                </div>
            }
            <div className='report-specific-buttons'>
                {props.children}
            </div>
            {
                props.showExport ?
                    <div
                        className='export-excel'
                    >
                        <DownloadToExcel
                            onDownload={props::handleExportToCsv}
                        />
                    </div> :
                    null
            }
            <CreateLayoutModal reportName={props.reportName}/>
            <UpdateLayoutModal reportName={props.reportName}/>
        </section>
    );

};

ReportGridHeader.displayName = 'ReportGridHeader';
ReportGridHeader.propTypes = {
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
    columnApi: PropTypes.object,
    gridApi: PropTypes.object.isRequired,
    hiddenColumns: PropTypes.arrayOf(PropTypes.instanceOf(ReportColumnState)),
    isSapUp: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    reportName: PropTypes.string.isRequired,
    responsibleExportToCSV: PropTypes.object,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showExport: PropTypes.bool,
    showReportLayout: PropTypes.bool,
    showResponsibleDealer: PropTypes.bool
};

ReportGridHeader.defaultProps = {
    showExport: true,
    showReportLayout: true,
    showResponsibleDealer: false
};

export default ReportGridHeader;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-header/report-header.js